import { create } from 'zustand';

export interface ProgressEntry {
  id: string;
  type: 'analysis' | 'research_assistant' | 'comparison';
  label: string;
  startedAt: number;
  progress?: { step: string; completed: number; total: number };
}

type State = {
  entries: ProgressEntry[];
};

type Action = {
  addEntry: (entry: ProgressEntry) => void;
  updateEntry: (id: string, updates: Partial<Omit<ProgressEntry, 'id'>>) => void;
  removeEntry: (id: string) => void;
};

const useGlobalProgressStore = create<State & Action>((set) => ({
  entries: [],
  addEntry: (entry) =>
    set((state) => ({
      entries: [
        // Replace if same id already exists (idempotent)
        ...state.entries.filter((e) => e.id !== entry.id),
        entry,
      ],
    })),
  updateEntry: (id, updates) =>
    set((state) => ({
      entries: state.entries.map((e) => (e.id === id ? { ...e, ...updates } : e)),
    })),
  removeEntry: (id) =>
    set((state) => ({
      entries: state.entries.filter((e) => e.id !== id),
    })),
}));

export default useGlobalProgressStore;
